module.exports = __webpack_public_path__ + "img/button_suffix_off.b8682e2e.svg";